<form
  #form="ngForm"
  novalidate
>
  @let vm = offshoreReportStore.vm();
  <h1 class="mb-4 justify-self-center text-xl">Position and Logistics</h1>

  <re-lat-long-template
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'position')"
    class="flex justify-end pt-2"
    name="position"
    id="position"
    title="Ship position"
    [required]="vm.isFieldRequired(tabId, sectionId, 'position')"
    [latLng]="positionAndWeatherStore.positionAndLogistics().position.value"
    [ngModel]="positionAndWeatherStore.positionAndLogistics().position.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'logDistance')"
    name="logDistance"
    id="logDistance"
    label="Log Distance"
    [unit]="units.nauticalMiles"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'logDistance')"
    [min]="0"
    [value]="positionAndWeatherStore.positionAndLogistics().logDistance.value"
    [ngModel]="positionAndWeatherStore.positionAndLogistics().logDistance.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'observedDistance')"
    name="observedDistance"
    id="observedDistance"
    label="Observed Distance"
    [unit]="units.nauticalMiles"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'observedDistance')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observedDistance')"
    [min]="0"
    [value]="
      positionAndWeatherStore.positionAndLogistics().observedDistance.value
    "
    [ngModel]="
      positionAndWeatherStore.positionAndLogistics().observedDistance.value
    "
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'logSpeed')"
    name="logSpeed"
    id="logSpeed"
    label="Log Speed"
    [unit]="'Knots'"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'logSpeed')"
    [min]="0"
    [value]="positionAndWeatherStore.positionAndLogistics().logSpeed.value"
    [ngModel]="positionAndWeatherStore.positionAndLogistics().logSpeed.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'observedSpeed')"
    name="observedSpeed"
    id="observedSpeed"
    label="Observed Speed"
    [unit]="'Knots'"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'observedSpeed')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observedSpeed')"
    [min]="0"
    [value]="positionAndWeatherStore.positionAndLogistics().observedSpeed.value"
    [ngModel]="
      positionAndWeatherStore.positionAndLogistics().observedSpeed.value
    "
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'courseOverGround')"
    name="courseOverGround"
    id="courseOverGround"
    label="Course Over Ground (COG)"
    [unit]="units.degrees"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'courseOverGround')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'courseOverGround')"
    [min]="0"
    [value]="
      positionAndWeatherStore.positionAndLogistics().courseOverGround.value
    "
    [ngModel]="
      positionAndWeatherStore.positionAndLogistics().courseOverGround.value
    "
  />
</form>
